import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';

import COOKIES_RESUME from '../../../cookiesResume';
import MESSAGES from '../../../messages';
import {CookieTabAccordionItem} from '../CookieTabAccordionItem/CookieTabAccordionItem';

import './CookieTabAccordionList.scss';

const CookieTabAccordionList = ({handleActiveCookie, activeCookie}) => {
  const [visiblity, setVisiblity] = useState(1);

  const handleTabAccordionItemVisiblity = (id) => {
    setVisiblity(id);
  };

  return (
    <div className="CookieTabAccordionList__container">
      <div className="CookieTabAccordionList__tabsTitle">
        {COOKIES_RESUME.map((cookie) => (
          <p
            key={cookie.id}
            className={classnames('CookieTabAccordionList__titleText', {
              CookieTabAccordionList__active: visiblity === cookie.id,
            })}
            onClick={() => handleTabAccordionItemVisiblity(cookie.id)}
          >
            <FormattedMessage {...MESSAGES[`${cookie.name.toUpperCase()}_TITLE`]} />
          </p>
        ))}
      </div>
      <div>
        {COOKIES_RESUME.map((cookie) => (
          <CookieTabAccordionItem
            key={cookie.id}
            id={cookie.id}
            title={cookie.title}
            name={cookie.name}
            description={cookie.description}
            isActive={activeCookie}
            isMandatory={cookie.isMandatory}
            handleActiveCookie={handleActiveCookie}
            visiblity={visiblity}
            handleTabAccordionItemVisiblity={handleTabAccordionItemVisiblity}
          />
        ))}
      </div>
    </div>
  );
};

CookieTabAccordionList.displayName = 'CookieTabAccordionList';

CookieTabAccordionList.propTypes = {
  /**
   * Set each cookie consent in object.
   */
  handleActiveCookie: PropTypes.func,

  /**
   * Object with defautl params of each cookie
   */
  activeCookie: PropTypes.object,
};

export default CookieTabAccordionList;
